import React from 'react';
import { Loader } from 'semantic-ui-react';

function LoadingPage() {
  return <Loader active>Loading user auth...</Loader>;
}

export default LoadingPage;
